import React, { createContext, useContext, useRef, useState } from "react";
import { useTreeContext } from "./TreeDataContext";
import axiosInstance, { handleApiError } from "../services/axiosService";
import { createChecksum } from "../commonFunctions/fileFolderConfig";
import { useAppOrgContext } from "./AppOrgContext";
import { getTreeDataForWorkflow } from "../utils/treeData/treeDataUtils";
const WorkflowContextApi = createContext();

const useWorkflowContext = () => useContext(WorkflowContextApi);
const WorkflowContext = ({ children }) => {
  const [selectedWorkflow, setSelectedWorkflow] = useState({
    id: "",
    name: ""
  });

  const modelerRef = useRef(null);
  const { setWorkflowExplorerData } = useTreeContext();
  const { currentChecksum } = useAppOrgContext();

  const fetchAllWorkflows = async () => {
    const { data } = await axiosInstance.get("/workflow");
    const treeData = getTreeDataForWorkflow(data);
    setWorkflowExplorerData(treeData);
  };

  const getWorkflowConfig = async () => {
    const modeler = modelerRef.current;
    const { xml } = await modeler.saveXML({ format: true });
    return { xml: xml };
  };

  const handleSaveWorkflow = async () => {
    try {
      const config = await getWorkflowConfig();
      const { message } = await axiosInstance.put(`/workflow/${selectedWorkflow.id}`, {
        xml_file: config.xml,
        name: selectedWorkflow.name
      });
      const newChecksum = createChecksum(config);
      currentChecksum.current = newChecksum;
      return { data: config, message };
    } catch (error) {
      handleApiError(error);
    }
  };

  return (
    <WorkflowContextApi.Provider
      value={{
        selectedWorkflow,
        modelerRef,
        getWorkflowConfig,
        handleSaveWorkflow,
        setSelectedWorkflow,
        fetchAllWorkflows
      }}
    >
      {children}
    </WorkflowContextApi.Provider>
  );
};

export default WorkflowContext;
export { useWorkflowContext };
